import { Link } from "react-router-dom";
import { useEffect } from "react";
import { ArrowLeft } from "lucide-react";
import { Footer } from "@/components/Footer";

const LOGO = "https://customer-assets.emergentagent.com/job_asilo-peramore/artifacts/qzmvlqzx_0945cabc-d0c0-4609-956c-55e1e91721a9.jpeg";

export const PolicyLayout = ({ title, updated, children }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="font-body text-slate-800 bg-[#f7f0e3] min-h-screen">
      <header className="bg-white shadow-sm">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 h-24 flex items-center justify-between">
          <Link to="/" data-testid="policy-logo-home">
            <img src={LOGO} alt="Logo Asilo Nido Per Amore" className="h-16 w-auto object-contain" />
          </Link>
          <Link to="/" data-testid="policy-back-home"
            className="inline-flex items-center gap-2 rounded-full bg-rose-50 text-rose-600 px-5 py-2.5 font-700 hover:bg-rose-100 transition-colors">
            <ArrowLeft className="h-4 w-4" /> Torna al sito
          </Link>
        </div>
      </header>

      <main className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-14 sm:py-20">
        <h1 className="font-heading text-3xl sm:text-4xl md:text-5xl font-700 text-slate-800">{title}</h1>
        {updated && <p className="mt-3 text-sm text-slate-500 font-600">Ultimo aggiornamento: {updated}</p>}
        <div className="mt-8 bg-white rounded-[2rem] shadow-sm p-7 sm:p-10 policy-content">{children}</div>
      </main>

      <Footer />
    </div>
  );
};
